import { Component } from '@angular/core';

@Component({
  selector: 'app-jjsv-footer',
  imports: [],
  templateUrl: './jjsv-footer.component.html',
  styleUrl: './jjsv-footer.component.scss',
})
export class JjsvFooter {}
